import { useState } from 'react';
import { Bell, Gear } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';

import { Badge, Button, Popover, Tabs, Typography } from 'antd';

import { useFetchAllInvitesDataQuery } from '@/services/invites';
import { useGetNotificationsQuery } from '@/services/notifications';
import styled, { css, StyledProp } from '@/styled';

import TabInvites from './TabInvites';
import TabUpdate from './TabUpdates';

function Notifications({ className }: StyledProp) {
  const notifications = useGetNotificationsQuery({ page: 1 });
  const invites = useFetchAllInvitesDataQuery({ page: 1 });
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const items = [
    {
      label: 'Atualizações',
      key: '1',
      children: <TabUpdate />
    },
    {
      label: 'Convites',
      key: '2',
      children: <TabInvites />
    }
  ];

  const hasNotifications = notifications?.data?.data?.length > 0;
  const hasInvites = invites?.data?.data?.length > 0;

  const handleOpenPopover = () => {
    setIsOpen(isOpen => !isOpen);
  };

  return (
    <Badge dot={hasNotifications || hasInvites}>
      <Popover
        trigger={['click']}
        placement='bottom'
        rootClassName={className}
        open={isOpen}
        onOpenChange={handleOpenPopover}
        content={
          <>
            <div className='header'>
              <Typography.Paragraph>Notificações</Typography.Paragraph>
              <Gear
                size={16}
                onClick={() => {
                  setIsOpen(false);
                  navigate('/notificacoes');
                }}
              />
            </div>

            <Tabs items={items} />
          </>
        }
      >
        <Button type='ghost'>
          <Bell />
        </Button>
      </Popover>
    </Badge>
  );
}

export default styled(Notifications)(
  ({ theme }) => css`
    width: 100%;
    max-width: 480px;

    .ant-popover-inner {
      padding: 0;
    }

    svg {
      color: ${theme.colorIcon};
      cursor: pointer;
    }

    .header {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin: 0;
      width: 100%;
      height: 48px;
      background: ${theme.variables.tabs.contentBackground};
      padding: ${theme.space.pxToRem(16)};
      border: 1px solid ${theme.variables.borderColor};
      border-bottom: 0;
      border-top-left-radius: ${theme.borderRadius}px;
      border-top-right-radius: ${theme.borderRadius}px;

      .ant-typography {
        margin: 0;
      }
    }

    .ant-tabs-nav {
      background: ${theme.variables.tabs.headerBackground};
      padding: ${theme.space.spacing(0, 6)};
      color: ${theme.colorTextSecondary};
      box-shadow: none;
      margin: 0;
      border-inline: 1px solid ${theme.variables.borderColor};

      &::before {
        border-bottom: 0;
      }

      .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: ${theme.colorTextBase};
      }
    }

    .ant-tabs-tabpane {
      background: ${theme.variables.tabs.contentBackground};
      border: 1px solid ${theme.variables.borderColor};
      border-top-width: 0px;
      border-bottom-left-radius: ${theme.borderRadius}px;
      border-bottom-right-radius: ${theme.borderRadius}px;
    }
  `
);
